import "@/entrypoints/application.css";

import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import { installCsrfRecovery } from "@/lib/csrfRecovery";
import { inertiaTitle, resolvePage } from "@/lib/inertiaApp";
import { installSiteAnalytics } from "@/lib/siteAnalytics";

installCsrfRecovery();
installSiteAnalytics();

createInertiaApp({
  resolve: resolvePage,
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
  title: inertiaTitle,
});
